module.exports = __webpack_public_path__ + "static/media/IMG_1477.423ae542.JPG";